// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberSharedExternalIdUpsearchModel {
    static getAttributeTypeMap() {
        return PrescriberSharedExternalIdUpsearchModel.attributeTypeMap;
    }
}
PrescriberSharedExternalIdUpsearchModel.discriminator = undefined;
PrescriberSharedExternalIdUpsearchModel.additionalProperties = false;
PrescriberSharedExternalIdUpsearchModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "externalIdType",
        "baseName": "externalIdType",
        "type": "PartyExternalIdType"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
];
//# sourceMappingURL=prescriberSharedExternalIdUpsearchModel.js.map